import { createRoot } from 'react-dom/client';

// third party
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';

// project imports
import * as serviceWorker from 'serviceWorker';
import App from 'App';
import { store } from 'store';

// style + assets
import 'assets/scss/style.scss';
import config from './config';
import './assets/scss/font.scss';
import './index.css';

// ==============================|| REACT DOM RENDER  ||============================== //

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
    <>
        <Provider store={store}>
            <BrowserRouter basename={config.basename}>
                <App />
            </BrowserRouter>
        </Provider>
    </>
);

serviceWorker.unregister();

// import { createRoot } from 'react-dom/client';

// // third party
// import { BrowserRouter } from 'react-router-dom';
// import { Provider } from 'react-redux';

// // project imports
// import * as serviceWorker from './serviceWorker';
// import App from './App';
// import { store } from './store';

// // style + assets
// import 'assets/scss/style.scss';
// import config from './config';
// import './assets/scss/font.scss';
// import './index.css';

// // ==============================|| SINGLE TAB RESTRICTION WITH HEARTBEAT ||============================== //

// const TAB_KEY = 'app_tab_key';
// const HEARTBEAT_INTERVAL = 2000; // 2s
// const LOCK_TTL = 7000; // 7s (lock expires if not refreshed)
// const tabId = Date.now().toString();

// // Function to write heartbeat
// function sendHeartbeat() {
//     const payload = JSON.stringify({
//         id: tabId,
//         ts: Date.now()
//     });
//     localStorage.setItem(TAB_KEY, payload);
// }

// // Function to check if lock is free or expired
// function isLockAvailable() {
//     const item = localStorage.getItem(TAB_KEY);
//     if (!item) return true;

//     try {
//         const { id, ts } = JSON.parse(item);
//         // If another tab owns it and it's still alive
//         if (id !== tabId && Date.now() - ts < LOCK_TTL) {
//             return false;
//         }
//     } catch {
//         return true;
//     }

//     return true;
// }

// // Try to acquire lock
// if (!isLockAvailable()) {
//     alert('This app is already open in another tab.');
//     window.location.replace('about:blank'); // safer than window.close()
//     throw new Error('Multiple tabs are not allowed');
// }

// // Take the lock
// sendHeartbeat();
// const heartbeatTimer = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL);

// // Listen for other tabs updating the lock
// window.addEventListener('storage', (event) => {
//     if (event.key === TAB_KEY && event.newValue) {
//         try {
//             const { id, ts } = JSON.parse(event.newValue);
//             if (id !== tabId && Date.now() - ts < LOCK_TTL) {
//                 alert('Another tab has taken over. This tab will now close.');
//                 clearInterval(heartbeatTimer);
//                 window.location.replace('about:blank');
//             }
//         } catch {
//             // ignore malformed
//         }
//     }
// });

// // Cleanup on unload
// window.addEventListener('beforeunload', () => {
//     const item = localStorage.getItem(TAB_KEY);
//     if (item) {
//         try {
//             const { id } = JSON.parse(item);
//             if (id === tabId) {
//                 localStorage.removeItem(TAB_KEY);
//             }
//         } catch {
//             localStorage.removeItem(TAB_KEY);
//         }
//     }
//     clearInterval(heartbeatTimer);
// });

// // ==============================|| REACT DOM RENDER  ||============================== //

// const container = document.getElementById('root');
// const root = createRoot(container);
// root.render(
//     <Provider store={store}>
//         <BrowserRouter basename={config.basename}>
//             <App />
//         </BrowserRouter>
//     </Provider>
// );

// serviceWorker.unregister();